
<app-detail-card
  [isLoading]="isLoading"
  [title]="getCardTitle()"
  [image]="physicalAsset.id"
  [generateQRCode]="true"
  [backLevels]="mode == getModes().NEW ? 3 : 2"
  [canUploadImage]="false"
  [contentToShow]="mode == getModes().NEW ? DetailCardContent.EMPTY : DetailCardContent.TABS"
  [tabs]="[
      { name: 'Maintenances' | translate, content:  maintenances }
    ]"
>

  <!-- General information -->
  <div class="form" sidebar-content>

    <div class="group-title">{{ 'General information' | translate }}</div>
    <div class="group">

      <!-- Model -->
      <mat-form-field>
        <mat-label>{{ 'Model' | translate }}</mat-label>
        <input matInput [value]="physicalAsset?.model?.name || equipment?.name" disabled readonly>
      </mat-form-field>

      <!-- Serial number -->
      <mat-form-field>
        <mat-label>{{ 'Serial number' | translate }}</mat-label>
        <input matInput [(ngModel)]="physicalAsset.serialNumber" required>
      </mat-form-field>

      <!-- Field service -->
      <mat-form-field appearance="fill">
        <mat-label>{{ 'Field service' | translate }}</mat-label>
        <mat-select [(value)]="physicalAsset.fieldServiceId">
          <mat-option *ngIf="!fieldServices || fieldServices.length == 0" [value]="null">{{ 'No field service found' | translate }}</mat-option>
          <mat-option *ngFor="let fieldService of fieldServices" [value]="fieldService.id">
            {{fieldService.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Setup date -->
      <mat-form-field>
        <input matInput [ngxMatDatetimePicker]="picker" [placeholder]="'Setup date' | translate" [(ngModel)]="setupDate" required>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <ngx-mat-datetime-picker #picker [showSpinners]="true" [showSeconds]="true" [stepHour]="1"
                                 [stepMinute]="1" [stepSecond]="1" color="primary"
                                 [enableMeridian]="true" [hideTime]="false">
        </ngx-mat-datetime-picker>
      </mat-form-field>

    </div>
  </div>

  <!-- Sidebar actions -->
  <ng-container sidebar-actions>
    <button *ngIf="mode == getModes().NEW" mat-raised-button color="primary" (click)="save()" [disabled]="!physicalAsset.validate()">{{ 'Create asset' | translate }}</button>
    <button *ngIf="mode == getModes().UPDATE" mat-raised-button color="primary" (click)="save()" [disabled]="!physicalAsset.validate()">{{ 'Save asset' | translate }}</button>
    <button *ngIf="mode == getModes().UPDATE" mat-raised-button color="warn" (click)="delete()" [disabled]="!physicalAsset.validate()">{{ 'Remove asset' | translate }}</button>
  </ng-container>

  <!-- Empty statement on new item -->
  <ng-container empty-statement>
    {{ 'Create a physical asset to start viewing associated maintenances' | translate }}
  </ng-container>

  <!-- Maintenances -->
  <ng-template #maintenances>

    <!-- Header -->
    <div class="header">

      <!-- Search bar -->
      <app-search-bar *ngIf="!environment.production" placeholder="Search maintenance..." (textSubmit)="filterMaintenances($event)"></app-search-bar>

      <div class="spacer"></div>

      <!-- Actions -->
      <div class="actions">
        <!-- No action -->
      </div>

    </div>

    <!-- Maintenances table -->
    <app-table
      [columns]="getMaintenancesTableColumns()"
      [rows]="getMaintenancesTableData()"
      [paginator]="maintenancesPaginator"
      (onItemClicked)="showMaintenance($event)"
    ></app-table>

  </ng-template>

</app-detail-card>

<app-scotty-card *ngIf="false" [title]="getCardTitle()" canGoBack="true" [backLevels]="mode == getModes().NEW ? 3 : 2">

  <div *ngIf="!isLoading; else loading" class="creation-form">

    <!-- General information -->
    <div class="group-title">{{ 'General information' | translate }}</div>
    <div class="group">

      <!-- Model -->
      <mat-form-field>
        <mat-label>{{ 'Model' | translate }}</mat-label>
        <input matInput [value]="physicalAsset.model ? physicalAsset.model.name : equipment.name" readonly>
      </mat-form-field>
      <br>

      <!-- Serial number -->
      <mat-form-field>
        <mat-label>{{ 'Serial number' | translate }}</mat-label>
        <input matInput [(ngModel)]="physicalAsset.serialNumber" required>
      </mat-form-field>
      <br>

      <!-- Field service -->
      <mat-form-field appearance="fill">
        <mat-label>{{ 'Field service' | translate }}</mat-label>
        <mat-select [(value)]="physicalAsset.fieldServiceId">
          <mat-option *ngIf="!fieldServices || fieldServices.length == 0" [value]="null">{{ 'No field service found' | translate }}</mat-option>
          <mat-option *ngFor="let fieldService of fieldServices" [value]="fieldService.id">
            {{fieldService.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <br>

      <!-- Setup date -->
      <mat-form-field>
        <input matInput [ngxMatDatetimePicker]="picker" [placeholder]="'Setup date' | translate" [(ngModel)]="setupDate" required>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <ngx-mat-datetime-picker #picker [showSpinners]="true" [showSeconds]="true" [stepHour]="1"
                                 [stepMinute]="1" [stepSecond]="1" color="primary"
                                 [enableMeridian]="true" [hideTime]="false">
        </ngx-mat-datetime-picker>
      </mat-form-field>
      <br>

      <button *ngIf="mode == getModes().NEW" class="save-asset" mat-raised-button color="primary" (click)="save()" [disabled]="!physicalAsset.validate()">{{ 'Create asset' | translate }}</button>

    </div>

    <button *ngIf="mode == getModes().UPDATE" class="save-asset" mat-raised-button color="primary" (click)="save()" [disabled]="!physicalAsset.validate()">{{ 'Save asset' | translate }}</button>
    <button *ngIf="mode == getModes().UPDATE" class="delete-asset" mat-raised-button color="warn" (click)="delete()" [disabled]="!physicalAsset.validate()">{{ 'Remove asset' | translate }}</button>

  </div>

</app-scotty-card>

<ng-template #loading>
  <app-scotty-spinner></app-scotty-spinner>
</ng-template>
